import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import * as styles from "./Header.module.scss";
import Logo from "../svg/Logo";
import MobileMenu from "./MobileMenu";

const Header = () => {
  // const [display, setDisplay] = useState(true)
  // let ts
  // const handleMouseStart = event => {
  //   ts = event.touches[0].clientY
  // }
  // var lastScrollTop = 0;
  // const handleMouseMove = event => {
  // console.log(event.changedTouches[0].clientY)
  // let te = event.changedTouches[0].clientY
  // if (ts > te + 5) {
  //   // console.log('down')
  //   setDisplay(false)
  // } else if (ts < te - 5) {
  //   // console.log('up')
  //   setDisplay(true)
  // }

  // }

  // useEffect(() => {
  //   if (window.screen.width < 1200) {
  //     window.addEventListener('touchstart', handleMouseStart)
  //     window.addEventListener('touchend', handleMouseMove)

  //   }

  //   return () => {
  //     window.addEventListener('touchstart', handleMouseStart)
  //     window.removeEventListener('touchend', handleMouseMove)

  //   }
  // }, [display])
  // <header style={{ opacity: `${display ? 1 : 0}` }}>
  return (
    <header>
      <div className={styles.logoPart}>
        <Link aria-label='logo' to='/'>
          <Logo />
        </Link>
      </div>
      <nav>
        <ul className={styles.mainNav}>
          <li>
            <Link to='/' activeClassName={styles.activeNav}>
              الرئيسية
            </Link>
          </li>
          <li>
            <Link to='/services' activeClassName={styles.activeNav}>
              خدماتنا
            </Link>
          </li>
          <li>
            <Link to='/about' activeClassName={styles.activeNav}>
              من نحن
            </Link>
          </li>
          <li>
            <Link to='/work' activeClassName={styles.activeNav}>
              أعمالنا
            </Link>
          </li>
          <li>
            <Link to='/ads' activeClassName={styles.activeNav}>
              إعلاناتنا
            </Link>
          </li>
          {/* <li>
            <Link to="/blog" activeClassName={styles.activeNav}>
              المدونة
            </Link>
          </li> */}

          <li>
            <a
              href={`https://en.rokkey.com`}
              rel='noopener noreferrer'
              style={{ fontSize: 14, marginRight: 60 }}
            >
              🌐 English
            </a>
          </li>
        </ul>
      </nav>
      <div className={styles.sidePart}>
        <Link
          className={styles.calltoAction}
          to='/contact'
          activeClassName={styles.activeNav}
        >
          احصل على استشارة
        </Link>
        <MobileMenu activeClassName={styles.activeNav} />
      </div>
    </header>
  );
};

export default Header;
